import CardCommon from '@/pages/opinion/components/CardCommon';
import UserScoreCommon from '@/pages/opinion/components/UserScoreCommon';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Row } from 'tea-component';
import TaptapLogo from '@/pages/opinion/assets/svg/TapTapLogo.svg';
import '@/pages/opinion/assets/scss/pages/feeds/GameStore.scss';
import { connect, useDispatch, useIntl } from 'umi';
import { DBO_TM } from '@op/utils/format';

const defaultStatsData = {
  'google play': { selected: [], lifetime: [] },
  'app store': { selected: [], lifetime: [] },
  taptap: { selected: [], lifetime: [] },
};

function GameStorMobileScore({
  gameInfo,
  list = [],
  loading,
  splitRegion = true,
  filter,
  isFeeds = false,
}: any) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [showMoreScore, setShowMoreScore] = useState(false);

  let globalResult = JSON.parse(JSON.stringify(defaultStatsData));

  let info: any = {};

  useEffect(() => {
    if (!gameInfo || !filter) return;

    dispatch({
      type: 'opinionStore/getStoreStats',
      payload: {
        ...filter,
        ...gameInfo,
        is_today: DBO_TM.isToday(filter),
        need_link: false,
        need_region: true,
        types: ['lifetime', 'selected'],
        channel: ['app store', 'google play', 'taptap'],
        channel_type: 'comments',
      },
    });
  }, [gameInfo, filter]);

  list?.forEach(
    ({
      new_list,
      type,
      old_list,
      link_of_start_time,
      link_of_end_time,
    }: any) => {
      let realNewList =
        new_list?.filter((item: any) => item.region !== 'global') || [];
      realNewList.forEach((item: any) => {
        // 这个是计算global的数据
        if (item.region === '') {
          let channel = item.channel;
          globalResult[channel] = {
            ...(globalResult[channel] || {}),
            [type]: { ...item },
          };
        }
      });
      let list: any = realNewList;

      if (splitRegion) {
        list.forEach((item: any) => {
          let { region, channel } = item;
          region = region || 'global';
          if (!info[region]) {
            info[region] = { region };
          }
          info[region][channel + '-' + type] = {
            ...item,
            oldTime: [link_of_start_time, link_of_end_time],
          };
        });
      }
    },
  );

  const userScore: any = {
    'google play': globalResult['google play'],
    'app store': globalResult['app store'],
    taptap: globalResult['taptap'],
  };
  const showMore = () => {
    setShowMoreScore(!showMoreScore);
  };

  //  * 是否有 taptap
  const hasTapTap = useMemo(() => {
    const channels = Array.isArray(filter?.channel)
      ? filter?.channel
      : filter?.channel?.comments || [];

    if (channels.length === 0) {
      return true;
    }

    return channels.includes('taptap');
  }, [filter]);

  const userScoreElements = useMemo(() => {
    let elements: Array<JSX.Element> = [];
    for (const key in userScore) {
      const { lifetime, selected } = userScore[key];
      if (!hasTapTap && key === 'taptap') {
        continue;
      }
      elements.push(
        <Fragment key={key}>
          <UserScoreCommon
            type="lifetime"
            filter={filter}
            platform={key}
            data={lifetime}
            isFeeds={isFeeds}
          ></UserScoreCommon>
          <UserScoreCommon
            type="selected"
            filter={filter}
            platform={key}
            data={selected}
            isFeeds={isFeeds}
          ></UserScoreCommon>
        </Fragment>,
      );
    }

    return elements;
  }, [userScore, hasTapTap]);

  const cardListRef = useRef<any>(null);
  const [isShowBtn, setIsShowBtn] = useState(false);

  const getListSize = useCallback(() => {
    const newHeight = cardListRef?.current?.scrollHeight;
    if (newHeight > 300 && hasTapTap) {
      setIsShowBtn(true);
    } else {
      setIsShowBtn(false);
    }
  }, []);

  useEffect(() => {
    getListSize();
  }, [loading]);

  useEffect(() => {
    window.addEventListener('resize', getListSize);

    return () => {
      window.removeEventListener('resize', getListSize);
    };
  }, [getListSize]);

  return (
    <CardCommon
      className={`feeds-userscorebox ${
        hasTapTap ? 'feeds-userscorebox--6' : ''
      } ${showMoreScore ? 'show-all' : ''}`}
      title={formatMessage({ id: 'User Score' })}
      loading={loading}
      loadingHeight={200}
      empty={!list || list.length === 0}
      emptyHeight={240}
    >
      <div>
        <Row className="feeds-userscorebox-row" ref={cardListRef}>
          <>{userScoreElements}</>
        </Row>
        {isShowBtn && (
          <div className="feeds-userscorebox-more" onClick={showMore}>
            {showMoreScore ? (
              <span>{formatMessage({ id: 'Show Less' })}</span>
            ) : (
              <>
                <span>{formatMessage({ id: 'Show' })}</span>
                <img src={TaptapLogo} />
              </>
            )}
          </div>
        )}
      </div>
    </CardCommon>
  );
}

export default connect((state: any) => {
  const { loading, opinionStore } = state;

  return {
    list: opinionStore.stats,
    loading: loading.effects['opinionStore/getStoreStats'],
  };
})(GameStorMobileScore);
